<template>
  <div class="choose-file">
    <!-- <div>从系统选择图片</div>
    <div>从图库选择图片</div>
    <van-button>取消</van-button> -->
    <van-action-sheet
      v-model="show1"
      :actions="actions1"
      cancel-text="取消"
      @cancel="cancel1"
      @close="cancel1"
      @select="choose1"
      :round="false"
    />
    <van-action-sheet
      v-model="show2"
      :actions="actions2"
      cancel-text="取消"
      @cancel="cancel2"
      @close="cancel2"
      @select="choose2"
      :round="false"
    />
    <div ref="listbox" class="selimg-p" v-show="showGallery">
      <!-- swiper end -->
      <div class="btn-wrap-r">
        <!-- href="#/single" -->
        <!-- <a href="javascript:;" class="btn btn-complete choose-complete1" @click="cancelChoose">返回</a> -->
        <a
          href="javascript:;"
          class="btn btn-complete choose-complete"
          @click="submitChoose"
          >完成</a
        >
      </div>
      <!-- <div style="text-align: center; padding-top: 50%; display: none;">
        <img src="/static/wap/match/images/blank_photo.png" alt="" />
      </div> -->
      <div class="list-wrap">
        <!-- <div class="selimg-list" v-for="(li, index) in list" :key="index">
          <div class="date">{{ li.createtime }}</div>
          <ul class="clearfix" id="list">
            <li class="item" v-for="item in li.img" :key="item.id">
              <img
                :data-index="item.key"
                v-lazy="item.url"
                class="pic"
                @click="showSwiper(item.key)"
              />
              <input
                :id="item.id"
                :data-id="item.id"
                :data-key="item.key"
                v-model="checkStatus[item.key]"
                data-content=""
                type="checkbox"
                class="check dd imgs"
                @click="checkChoose(item, $event)"
              />
            </li>
          </ul>
        </div> -->
        <van-list
          v-model="loading"
          :error.sync="error"
          :finished="finished"
          finished-text="没有更多图片了"
          error-text="请求失败，点击重新加载"
          @load="getList(status)"
        >
          <van-cell
            class="selimg-list"
            v-for="(li, index) in list"
            :key="index"
          >
            <div class="date">{{ li.createtime }}</div>
            <ul class="clearfix" id="list">
              <li class="item" v-for="item in li.img" :key="item.id">
                <img
                  :data-index="item.key"
                  v-lazy="item.url"
                  class="pic"
                  @click="showSwiper(item)"
                />
                <input
                  :id="item.id"
                  :data-id="item.id"
                  :data-key="item.key"
                  v-model="checkStatus['id' + item.id]"
                  data-content=""
                  type="checkbox"
                  class="check dd imgs"
                  @click="checkChoose(item, $event)"
                />
              </li>
            </ul>
          </van-cell>
        </van-list>
      </div>
      <!-- 列表 end -->
      <div class="swiper-wrap selimg-all" v-show="isShowSwiper">
        <div class="swiper-container detail">
          <div class="swiper-wrapper" id="swiperlist">
            <div
              class="swiper-slide"
              v-for="(item, index) in all_img"
              :key="index"
            >
              <img :src="item.url" />
              <input
                :id="item.id"
                :data-id="item.id"
                :data-key="item.key"
                v-model="checkStatus['id' + item.id]"
                data-content=""
                type="checkbox"
                class="check dd imgs"
                @click="checkChoose(item, $event)"
              />
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <!-- <a class="del-btn" href="javascript:void(0)" @click="deleteUploadSwiper()"></a> -->
          <a
            class="close-btn"
            href="javascript:void(0)"
            @click="hideSwiper"
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/js/swiper.js";
export default {
  data() {
    return {
      show1: false,
      actions1: [
        { name: "从系统选图（系统相册）" },
        { name: "从图库选图（已修好，发布成功的图片）" },
      ],
      show2: false,
      actions2: [
        { name: "从人工精修已修好的图片中选取" },
        { name: "从AI修图已修好的图片中选取" },
        { name: "从已发布的摄影作品中选取" },
      ],
      list: [],
      all_img: [],
      uploadList: [],
      showGallery: false,
      isShowSwiper: false,
      swiper: "",
      realIndex: 0,
      checkStatusList: {
        master: [],
        ai: [],
        issue: [],
      },
      checkStatus: [],
      checkVal: [],
      status: "",
      imgs: [],
      img: "",
      // $imgs: document.querySelectorAll(".imgs"),
      // 列表请求
      pagesize: 1,
      error: false,
      loading: false,
      finished: false, //每次重置 是否翻到最后一页
    };
  },
  props: {
    // 系统/图库选择
    chooseForm1: {
      type: Boolean,
    },
    // 传图数量限制
    // limit: {
    //   type: Number,
    //   default: 1,
    // },
    max: {
      type: Number,
    },
    uploadImages: {
      type: Array,
    },
    chooseType: {
      type: String,
    },
  },
  watch: {
    chooseForm1: {
      immediate: true,
      handler(val) {
        this.show1 = val;
        console.log(val);
      },
    },
  },
  methods: {
    // 选择从系统还是图库选图
    choose1(action, index) {
      console.log(action, index);
      if (index == 0) {
        // 从系统选择
        this.$emit("chooseFromSys");
        this.cancel1();
      }
      if (index == 1) {
        this.show2 = true;
        this.cancel1();
      }
    },
    // 选择从图库中哪种方式选图
    choose2(action, index) {
      console.log(action, index);
      // 每次重选时重置列表数据
      this.pagesize = 1;
      this.finished = false;
      this.list = [];
      this.all_img = [];
      // 根据选择返回数据
      switch (index) {
        case 0: // master 人工精修
          this.status = "master";
          this.getList("master");
          break;
        case 1: // ai Ai修图
          this.status = "ai";
          this.getList("ai");
          break;
        case 2:
          // issue 摄影
          this.status = "issue";
          this.getList("issue");
          break;
      }
    },
    // 关闭系统/图库面板
    cancel1() {
      this.$emit("changeChooseForm1", false);
    },
    // 关闭图库面板
    cancel2() {
      this.$emit("changeChooseForm2", false);
    },
    initStatus() {
      // 初始化图片选择情况
      // 还需要关联 单图/多图 在外层删除图库图片的情况 用sessionStorage判断
      // console.log(this.checkVal, this.checkVal.length);
      // 默认清理选中状态
      this.checkStatus = [];
      // 单图不做记录
      if (this.chooseType == "single") {
        return false;
      }

      this.checkVal = JSON.parse(sessionStorage.getItem("checkVal")) || [];
      // console.log(this.checkVal);
      if (this.checkVal.length > 0) {
        for (let item of this.checkVal) {
          // document.getElementById(item).checked = true;
          // console.log(document.getElementById(item).dataset);
          if (
            document.getElementById(item) != undefined &&
            document.getElementById(item).dataset != undefined
          ) {
            this.checkStatus["id" + item] = true;
          }
        }
      }
      console.log("init: ", this.checkVal);
      // 有新发布的数据会改变key值
      // 初始化imgs列表
      // this.imgs = JSON.parse(JSON.stringify(this.uploadImages));
      // 第一页的时候,同步imgs和父组件传进的form.imgs
      // 不需要每次都赋值,以免滚动加载更多数据时被重置回来
      if (this.pagesize == 1) {
        this.imgs = this.uploadImages;
      }
    },
    filterCheck(checkVal) {
      if (checkVal.length <= 0) {
        sessionStorage.removeItem("checkVal");
      } else {
        sessionStorage.setItem("checkVal", JSON.stringify(checkVal));
      }
    },
    // 读接口获取图库数据
    // 参数 master/ai/issue
    getList(status) {
      let params = {
        page: this.pagesize,
        status: status,
      };
      this.axios.post("/match/wapOldImg", params).then((res) => {
        // 根据数据展示列表，并关闭选项栏
        let data = res.data;
        if (data.code == 200) {
          if (data.data.all_img && data.data.all_img.length == 0) {
            this.finished = true;
          }

          this.loading = false;
          // console.log(data);
          this.show2 = false;
          this.showGallery = true;
          // this.$set(this, "list", data.data.list);
          // this.$set(this, "all_img", data.data.all_img);
          if (this.pagesize == 1) {
            this.list = data.data.list;
            this.all_img = data.data.all_img;
          } else {
            this.list = this.list.concat(data.data.list);
            this.all_img = this.all_img.concat(data.data.all_img);
          }

          this.$nextTick(() => {
            this.initStatus();
          });

          this.pagesize++;
        }
      });
    },
    // 选图并查看是否超出限制数量
    checkChoose(item, e) {
      // 判断图片数量是否超过限制
      console.log("beforexx: ", this.imgs);
      let target = e.currentTarget;
      // console.log(this.checkStatus);
      // console.log(e);
      if (!target.checked) {
        // 取消勾选
        this.checkVal = this.checkVal.filter((val) => {
          return val != target.id;
        });
        this.filterCheck(this.checkVal);

        // 取消上传列表的选择
        // 单图
        if (this.chooseType == "single") {
          this.imgs = [];
        }
        // 多图
        if (this.chooseType == "multi") {
          let newA = this.imgs.filter((val) => {
            // console.log(val, !val.id || (val.id && val.id != item.id));
            return !val.id || (val.id && val.id != item.id);
          });
          this.imgs = newA;
          console.log("filter: ", this.imgs);
        }
      } else {
        // 添加图片，勾选
        // 单图
        if (this.chooseType == "single") {
          this.checkVal = [];
          this.checkVal.push(target.id);
          this.filterCheck(this.checkVal);

          // 单独选中当前图片
          this.checkStatus = [];
          this.checkStatus["id" + item.id] = true;
          this.imgs = [];
          this.imgs.push(item);
        }
        // 多图
        if (this.chooseType == "multi") {
          this.imgs = this.imgs || [];
          let imgsLength = this.imgs.length;
          if (imgsLength == this.max) {
            // 超过数量，提示不能上传了
            this.$toast.fail("最多只能上传" + this.max + "张图");
            e.preventDefault();
          }
          if (this.imgs && imgsLength < this.max) {
            // 没超过数量
            this.checkVal.push(target.id);
            this.filterCheck(this.checkVal);

            this.imgs.push(item);
            // console.log(this.imgs);
          }
        }
        // 组照 不做
        // 视频 同单图
        // console.log("增加图片：", this.imgs);
      }
      console.log("改变后的imgs数组：", this.imgs);
    },
    // 返回不传
    cancelChoose() {
      this.isShowSwiper = false;
      this.showGallery = false;
      this.$refs.listbox.scrollTop = 0;
    },
    // 提交图库选图结果
    submitChoose() {
      // console.log("你选择了XX张图片");
      console.log("subChoose:", this.imgs);
      if (this.checkVal.length > 0 && this.imgs) {
        // 将url赋值为真实图片路径
        for (let item of this.imgs) {
          // 判断是否图库选图
          if (item.up_url != undefined) {
            item.url = item.up_url;
          }
        }
        // 提交时，储存选择结果和上传列表
        // this.checkStatusList[this.status] = this.checkVal;
        sessionStorage.setItem("checkVal", JSON.stringify(this.checkVal));
        // this.checkStatusList[this.status] = this.checkVal;
        // if (this.chooseType == "single") {
        this.$emit("chooseComplete", this.imgs);
        // }

        // if ((this.chooseType == "multi" && this.imgs.length > 0)) {
        //   this.$emit("chooseComplete");
        // }
        // this.$emit("update:choose-completes", this.imgs);
      } else {
        sessionStorage.removeItem("checkVal");
      }
      this.cancelChoose();
    },
    // 初始化大图预览
    initSwiper() {
      var that = this;
      // var mySwiper =
      this.swiper = new Swiper(".swiper-container", {
        initialSlide: that.realIndex,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        // loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          // slideChangeTransitionEnd
          slideChangeTransitionEnd: function() {
            that.realIndex = this.realIndex;
            // console.log("show idx: ", that.realIndex);
          },
        },
      });
    },
    // 大图预览面板
    showSwiper(item) {
      // console.log(item);
      let index = 0;
      for (let i = 0, len = this.all_img.length; i < len; i++) {
        // console.log(item.id, this.all_img[i].id);
        if (item.id == this.all_img[i].id) {
          index = i;
        }
      }
      // console.log(item)
      this.isShowSwiper = true;
      this.realIndex = index;
      this.initSwiper();
      // this.$nextTick(() => {
      //   this.initStatus();
      // });
    },
    hideSwiper() {
      this.isShowSwiper = false;
    },
  },
};
</script>

<style lang="scss">
@import "../../node_modules/swiper/css/swiper.min.css";
.choose-file {
  position: relative;
  z-index: 11;
  .swiper-wrap {
    position: absolute;
    top: 0;
    height: 100vh;
    overflow: hidden;
    width: 100%;
    background: rgba(0, 0, 0, 1);
  }
  .van-list__finished-text {
    padding-bottom: 100px;
  }
}
</style>
